export default [{"url":"https://hayzedd-test4-0.api.invexerp.io","name":"Branch 1","port":"5030","isStore":true,"isHQ":true}]